var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.031,
    height: 16.647,
    viewBox: "0 0 21.031 16.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17071",
    "data-name": "Group 17071",
    transform: "translate(14915.031 -7070)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38135",
    "data-name": "Path 38135",
    d: "M4.532,17.181c0,.961.008,1.92,0,2.879a.938.938,0,1,1-1.876.013c-.005-.881-.008-1.762,0-2.643a.286.286,0,0,0-.227-.334,3.571,3.571,0,0,1-.012-6.762.306.306,0,0,0,.241-.355q-.009-4.479,0-8.959A.937.937,0,0,1,3.907.059a.957.957,0,0,1,.624.966q0,2.423,0,4.846c0,1.371,0,2.741,0,4.112a.291.291,0,0,0,.226.337,3.576,3.576,0,0,1-.022,6.78C4.671,17.123,4.609,17.15,4.532,17.181ZM5.3,13.709a1.714,1.714,0,1,0-1.72,1.713A1.71,1.71,0,0,0,5.3,13.709Z",
    transform: "translate(-14915.031 7077.183) rotate(-90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38136",
    "data-name": "Path 38136",
    d: "M4.532,3.85c0-.961.008-1.92,0-2.879A.938.938,0,1,0,2.653.958c-.005.881-.008,1.762,0,2.643a.286.286,0,0,1-.227.334A3.571,3.571,0,0,0,2.415,10.7a.306.306,0,0,1,.241.355q-.009,4.479,0,8.959a.937.937,0,0,0,1.255.962.957.957,0,0,0,.624-.966q0-2.423,0-4.846c0-1.371,0-2.741,0-4.112a.291.291,0,0,1,.226-.337,3.576,3.576,0,0,0-.022-6.78C4.671,3.908,4.609,3.88,4.532,3.85ZM5.3,7.322a1.714,1.714,0,1,1-1.72-1.713A1.71,1.71,0,0,1,5.3,7.322Z",
    transform: "translate(-14915.031 7086.647) rotate(-90)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.5b64fd9e.svg";
export { ForwardRef as ReactComponent };